<!--
 * @Description: 病房表单组件
 * @Author: gaohc
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-dialog class="ward-details-dialog" width="650px" :title="dialogTitle"
      :visible.sync="visible" :close-on-click-modal="false" @open="initData"
      :before-close="handleCancel" center>
      <div class="dialog-body">
        <el-form :model="wardForm" ref="wardForm" :rules="rules">
          <el-form-item label="病房名称" prop="name" :label-width="formLabelWidth">
            <el-input v-model.trim="wardForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="起始病床号" prop="bedStartNo" :label-width="formLabelWidth">
            <el-input v-model.number="wardForm.bedStartNo" @blur="getWardList" autocomplete="off">
            </el-input>
          </el-form-item>
          <el-form-item label="病床数量" prop="bedAmount" :label-width="formLabelWidth">
            <el-input-number v-model="wardForm.bedAmount" :min="0" :max="50" 
              label="病床数量" @blur="getWardList" @change="getWardList">
            </el-input-number>
          </el-form-item>
          <el-form-item label="病房预览" :label-width="formLabelWidth">
            <el-row class="ward-list-main" type="flex" :gutter="20" v-if="wardList.length">
              <el-col v-for="(item, index) in wardList" :key="index" :span="4">
                  <div class="grid-content bg-purple">
                    <div class="ward-text">{{ item }}床</div>
                  </div>
              </el-col>
            </el-row>
            <div style="padding-left: 12px;" v-else>- -</div>
          </el-form-item>
        </el-form>
        <div class="plus-bed-warp">
          <el-checkbox :true-label="1" :false-label="0" v-model="wardForm.isNeedAddBed">
            需要加床
          </el-checkbox>
          <div v-if="wardForm.isNeedAddBed" style="margin-top: 15px">
            <div>
              <el-input placeholder="例 01，08，109" v-model="wardForm.bedAddNo">
                <template slot="append">
                  <span style="color: #000000">床</span>
                </template>
              </el-input>
            </div>
            <div class="tips-text">病床之间用逗号隔开</div>
          </div>
        </div>
      </div>
      <div class="dialog-footer bk-wizard-bottons">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSaveWardData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Constant from "@/global/Constant.js";
import depStore from "./DepStore.js";

export default {
  name: "InpatientWardForm",
  depStore,
  props: ["visible", "mode", "secondDepId", "addSource", "inpatientId"],

  data() {
    let checkBedAmont = (_rule, value, callback) => {
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字值"));
      } else {
        if (value > 50) {
          callback(new Error("病床数量最多50张"));
        } else {
          callback();
        }
      }
    };
    return {
      wardForm: {
        name: "",
        bedStartNo: 1,
        bedAmount: 20,
        isNoaccompanyWard: 0,
        isNeedAddBed: 0,
        bedAddNo: "",
      },
      checked: true,
      wardList: [],

      formLabelWidth: "120px",

      rules: {
        name: [{required: true, message: "请输入病房名称", trigger: "blur"},
               {max: 50, message: "病房名称最多50字，请修改", trigger: "blur"}],
        bedStartNo: [{required: true, message: "起始病床号不能为空", trigger: "blur"},
                     {type: "number", message: "起始病床号必须为数字值"}],
        bedAmount: [{validator: checkBedAmont, trigger: "blur"}],
      }
    };
  },
  computed: {
    dialogTitle() {
      switch (this.mode) {
        case "add":
          return "新增病房";
        case "edit":
          return "编辑病房";
        case "details":
          return "病房详情";
        default:
          return "编辑病房";
      }
    },
  },
  methods: {
    //保存病房信息
    handleSaveWardData() {
      this.$refs["wardForm"].validate((valid) => {
        if (!valid) return;
        if (!this.wardForm.isNeedAddBed && !this.wardForm.bedAmount) {
          this.$message({
            message: "请填写病床信息",
            type: "warning",
          });
          return;
        }
        if (this.wardForm.isNeedAddBed && !this.wardForm.bedAddNo) {
          this.$message({
            message: "请新增需要加床的床位号",
            type: "warning",
          });
          return;
        }
        if (!this.wardForm.isNeedAddBed) this.wardForm.bedAddNo = "";
        console.log(this.wardForm, 8888)
        if (this.addSource == "secondDepAdd") {
          depStore.commit("changeInpatientWard", this.wardForm);
          if (this.mode == "editNotHaveId") {
            this.$emit("add-inpatient", "editNotHaveId");
          } else {
            this.$emit("add-inpatient", "Saved");
          }
          this.$emit("close-dialog", false);
        } else {
          this.handelUpDateWard();
        }
      });
    },

    handelUpDateWard() {
      let [header, esParam] = this.encryptionUtil.encryptAndSignBody(this.wardForm,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_DEPARTMENT_INPATIENT,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then((result) => {
        if (result == null) {
          return;
        }

        this.$emit("close-dialog", true);
      });
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    getWardList() {
      if (this.wardForm.bedStartNo && this.wardForm.bedAmount) {
        this.wardList = this.getWardListFormStartAndEndNumber(this.wardForm.bedStartNo, 
          this.wardForm.bedAmount);
      } else {
        this.wardList = [];
        this.wardForm.bedNoList = [];
      }
    },

		// 根据用户输入床位号码和数量生成床位首尾号
    getWardListFormStartAndEndNumber(start, total) {
      let step = start - 1;
      return Array.apply(null, {length: total}).map(()=> {
        step++;
        return step > 9 ? step.toString() : "0" + step;
      });
    },

    initData() {
      this.clearData();
      if (this.mode == "add") {
        this.wardList =  this.getWardListFormStartAndEndNumber(this.wardForm.bedStartNo, 
          this.wardForm.bedAmount);
        depStore.commit("changeInpatientWard", {});
      } else if (this.mode == "edit") {
        let params = {id: this.inpatientId};
        let header = this.encryptionUtil.signatureParams(params,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_DEPARTMENT_INPATIENT_DO,
          param: params,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          if (result.data.isHavaNoFinishOrder) {
            this.$message({
              message: "该病房有关联未完成订单,暂不支持修改",
              type: "warning",
            });
            this.$emit("close-dialog", false);
            return;
          }

          this.wardForm = result.data;
          this.wardList = this.getWardListFormStartAndEndNumber(result.data.bedStartNo, 
            result.data.bedAmount);
        });
      } else {
        this.wardForm = depStore.state.inpatientWard;
      }
    },

    clearData() {
      if (this.mode == "add")
        this.wardForm = {
          name: "",
          bedStartNo: 1,
          bedAmount: 20,
          isNoaccompanyWard: 0,
          isNeedAddBed: 0,
          bedAddNo: "",
        };
    },
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.ward-details-dialog .el-form .el-input {
  width: 220px;
}

.ward-list-main {
  flex-wrap: wrap;
  max-height: 160px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-right: 25px;
}

.ward-text {
  width: 65px;
  height: 28px;
  background: #feffff;
  border-radius: 3px;
  border: 1px solid #c2d8fb;
  color: #333333;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  margin-bottom: 10px;
}

.plus-bed-warp {
  padding-left: 30px;
}

.tips-text {
  color: #ff7474;
  font-size: 12px;
  margin-top: 15px;
}

.dialog-footer {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/components/departmentList/InpatientWardForm.vue